import { SystemlogModel } from 'src/Libs/installations/models'
import { isSmartMeterGatewayLog } from './is-smart-meter-gateway-log'

/**
 * Returns the ids of the open smart meter gateway logs, which have to be resolved once the smart meter gateway SKI is trusted
 */
export const getUnresolvedSmartMeterGatewayLogIds = (logs: Pick<SystemlogModel, 'id' | 'errorType' | 'errorCode' | 'isResolved'>[]): number[] =>
  logs.filter(log => !log.isResolved && isSmartMeterGatewayLog(log)).map(log => log.id)
